import { useQuery } from '@tanstack/react-query';
import { lmsApiClient } from '@/modules/lms/services/lmsApiClient';
import { API_ENDPOINTS } from '@/config/apiEndpoints';

export const useLlmCostSummary = (dateFrom, dateTo, options = {}) => {
  return useQuery({
    queryKey: ['lms', 'costs', 'summary', dateFrom, dateTo],
    queryFn: () =>
      lmsApiClient.get(API_ENDPOINTS.LMS_COSTS_SUMMARY, {}, {
        date_from: dateFrom,
        date_to: dateTo,
      }),
    enabled: !!dateFrom && !!dateTo,
    staleTime: 5 * 60 * 1000,
    retry: 1,
    ...options,
  });
};

export const useLlmCostDetail = (filters = {}, options = {}) => {
  return useQuery({
    queryKey: ['lms', 'costs', 'detail', filters],
    queryFn: () =>
      lmsApiClient.get(API_ENDPOINTS.LMS_COSTS_DETAIL, {}, filters),
    enabled: !!filters.date_from && !!filters.date_to,
    staleTime: 5 * 60 * 1000,
    retry: 1,
    ...options,
  });
};
